import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric } from "web-vitals";
import { trackEvent } from "./analytics";

/**
 * Report Core Web Vitals to the existing analytics pipeline so we can
 * notice regressions after shipping new homepage/card components.
 * Fires once per metric per page navigation.
 */
const report = (metric: Metric) => {
  try {
    trackEvent("web_vital", {
      name: metric.name,
      value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value),
      rating: metric.rating,
      navigation_type: metric.navigationType,
      id: metric.id,
    });
  } catch {
    /* swallow - never block on telemetry */
  }
};

export const installWebVitals = () => {
  if (typeof window === "undefined") return;
  try {
    onCLS(report);
    onINP(report);
    onLCP(report);
    onFCP(report);
    onTTFB(report);
  } catch {
    /* ignore */
  }
};
